export default "__VITE_ASSET__BLzJe9ci__"